import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Star } from 'lucide-react';
const productBadges = [{
  icon: '📚',
  label: '3 TOMOS COMPLETOS'
}, {
  icon: '🎁',
  label: '3 BONOS GRATIS'
}, {
  icon: '⚡',
  label: 'ACCESO INMEDIATO'
}];
const stats = [{
  value: '+180',
  label: 'Páginas'
}, {
  value: '+50',
  label: 'Herramientas'
}, {
  value: '3-13',
  label: 'Años'
}, {
  value: '4.9⭐',
  label: 'Rating'
}];
export const Hero = () => {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="relative w-full overflow-hidden bg-hero-gradient" data-id="element-107">
      {/* Subtle decorative elements */}
      <div className="pointer-events-none absolute inset-0 z-0" data-id="element-108">
        <div className="absolute left-0 top-0 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#A855F7]/5 blur-[120px]" data-id="element-109" />
        <div className="absolute right-0 top-[40%] h-[400px] w-[400px] translate-x-1/3 rounded-full bg-[#7C3AED]/5 blur-[100px]" data-id="element-110" />
      </div>

      <div className="relative z-10 mx-auto max-w-[720px] px-5 py-12 sm:py-16 md:py-20 text-center" data-id="element-111">
        {/* Top badge */}
        <motion.div initial={{
        opacity: 0,
        y: -12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-8 inline-flex items-center gap-2 overflow-hidden rounded-full border border-[#7C3AED]/25 bg-[#EDE9FF] px-4 py-1.5 shadow-card-light" data-id="element-112">
          <div className="flex gap-0.5" data-id="element-113">
            {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-[#D4A017] text-[#D4A017]" data-id="element-114" />)}
          </div>
          <span className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#6B21A8] sm:text-xs" data-id="element-115">
            +500 MAMÁS ARGENTINAS · CALIFICACIÓN 4.9/5
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mx-auto max-w-[640px] font-heading text-[36px] font-bold leading-[1.1] tracking-tight text-[#1A0A2E] sm:text-5xl md:text-[52px]" data-id="element-116">
          <span className="font-bold" data-id="element-117">La Ansiedad de Tu Hijo</span>
          <br data-id="element-118" />
          <div className="relative inline-block" data-id="element-119">
            <span className="text-shadow-violet relative z-10 font-black text-violet-gradient text-[42px] sm:text-[64px]" data-id="element-120">
              No Puede Esperar
            </span>
            <motion.div initial={{
            width: 0
          }} animate={{
            width: '80px'
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="absolute -bottom-2 left-1/2 h-1 -translate-x-1/2 bg-violet-gradient rounded-full" data-id="element-121" />
          </div>
          <br data-id="element-122" />
          <span className="font-bold mt-2 inline-block" data-id="element-123">Otro Mes Más.</span>
        </motion.h1>

        {/* Product Label */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mt-8 flex justify-center" data-id="element-124">
          <div className="inline-flex items-center gap-3 rounded-full bg-[#6B21A8] px-5 py-2" data-id="element-125">
            <span className="text-[#D4A017] font-bold" data-id="element-126">· · ·</span>
            <span className="text-sm font-bold text-white tracking-wide" data-id="element-127">
              KIT HIJOS EN CALMA™ 2026
            </span>
            <span className="text-[#D4A017] font-bold" data-id="element-128">· · ·</span>
          </div>
        </motion.div>

        {/* Product mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92,
        y: 24
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mt-10 mb-8" data-id="element-129">
          <div className="pointer-events-none absolute inset-0 -z-10 mx-auto h-full w-[85%] rounded-full bg-[#A855F7]/10 blur-[80px]" data-id="element-130" />
          <motion.img src="https://cdn.magicpatterns.com/uploads/61Sr6V8H9mNzGb8bRwPf73/edited-photo.png" alt="Kit Hijos en Calma 2026" className="mx-auto w-full max-w-[620px] drop-shadow-2xl" loading="eager" animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-131" />
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mx-auto mt-2 max-w-[560px]" data-id="element-132">
          <motion.button onClick={scrollToPricing} whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} className="relative flex h-[68px] w-full items-center justify-center rounded-[14px] bg-violet-gradient px-6 text-[16px] font-bold uppercase tracking-wide text-white shadow-btn-violet sm:text-[20px]" data-id="element-133">
            💥 Quiero Calmar la Ansiedad de Mi Hijo Ahora
          </motion.button>

          <p className="mt-4 flex flex-wrap items-center justify-center gap-x-2 text-xs text-[#4B3B6B] sm:text-sm" data-id="element-134">
            <Lock size={14} data-id="element-135" /> Pago seguro · Garantía 7 días · Mercado Pago ·
            Acceso en 5 minutos
          </p>
        </motion.div>

        {/* Subheadline */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mx-auto mt-10 max-w-[560px]" data-id="element-136">
          <p className="text-[18px] leading-[1.7] text-[#4B3B6B]" data-id="element-137">
            Tu hijo puede empezar a calmarse esta semana: protocolo de crisis,
            rutinas antiansiedad y técnicas de regulación por edad.
          </p>
          <p className="mt-4 text-[20px] font-bold text-[#1A0A2E]" data-id="element-138">
            Sin improvisar. Sin quedarte paralizada cuando todo explota a las 11
            de la noche.
          </p>
        </motion.div>

        {/* Product badge row */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-139">
          {productBadges.map(b => <span key={b.label} className="inline-flex items-center gap-2 rounded-full border border-[#A855F7]/30 bg-[#EDE9FF] px-4 py-2 text-xs font-bold tracking-wide text-[#6B21A8] sm:text-sm" data-id="element-140">
              <span data-id="element-141">{b.icon}</span>
              {b.label}
            </span>)}
        </motion.div>

        {/* Stats row */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4" data-id="element-142">
          {stats.map(s => <motion.div key={s.label} whileHover={{
          y: -4
        }} className="flex flex-col items-center justify-center rounded-[16px] border border-[#A855F7]/20 bg-white py-5 shadow-card-light transition-shadow hover:shadow-card-hover" data-id="element-143">
              <div className="font-heading text-2xl font-bold text-violet-gradient sm:text-3xl" data-id="element-144">
                {s.value}
              </div>
              <div className="mt-1 text-xs font-semibold text-[#4B3B6B] sm:text-sm" data-id="element-145">
                {s.label}
              </div>
            </motion.div>)}
        </motion.div>

        {/* Secondary CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="mt-10 text-center" data-id="element-146">
          <button onClick={() => document.getElementById('contents')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-sm font-medium text-[#7C3AED] underline hover:text-[#6B21A8]" data-id="element-147">
            Ver qué incluye el Kit completo ↓
          </button>
        </motion.div>
      </div>
    </section>;
};